import WOW from '../client-admin-app/wow.min'
import $ from "jquery";

//console.log('accept payment custom scripts');

let $offset = 220;
if ( $(window).width() < 768) {
    $offset = 100;
} else {
    $offset = 220;
}

$(window).resize(function() {
    if ( $(window).width() < 768) {
        $offset = 100;
    } else {
        $offset = 220;
    }
});

new WOW({
    offset: $offset
}).init();
